import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { forceScrollToTop, forceScrollToContent } from '../utils/scrollToTop';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Special handling for booking page - scroll to main content area
    if (pathname === '/booknow') {
      forceScrollToContent(20); // 20px offset from header
    } else {
      // For all other pages, scroll to top normally
      forceScrollToTop();
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;